import React from "react";
import { SelectAddressForm } from "@app/components/forms";
import { Address } from "@app/provider";
import { Button } from "@natera/form";
import { defineMessages, useIntl } from "react-intl";

export const messages = defineMessages({
  sampleDrawMPSelectAddressNextButtonText: {
    id: "sampleDrawMPSelectAddressNextButtonText",
    defaultMessage: "Next",
  },
  sampleDrawMPSelectAddressBackButtonText: {
    id: "sampleDrawMPSelectAddressBackButtonText",
    defaultMessage: "Back",
  },
  sampleDrawMPSelectAddressNewAddressButton: {
    id: "sampleDrawMPSelectAddressNewAddressButton",
    defaultMessage: "Enter a New Address",
  },
});

type Props = {
  addresses: Address[];
  onAddNewAddress: () => void;
  onSubmit: (address: Partial<Address>) => void;
  onBack?: () => void;
};

const SampleDrawMPSelectAddress: React.FC<Props> = ({
  addresses,
  onAddNewAddress,
  onSubmit,
  onBack,
}) => {
  const intl = useIntl();

  return (
    <SelectAddressForm
      addresses={addresses}
      onSubmit={onSubmit}
      actions={
        <>
          <Button
            onClick={onAddNewAddress}
            type="button"
            outlined
            data-testid="enter-new-address-button"
          >
            {intl.formatMessage(
              messages.sampleDrawMPSelectAddressNewAddressButton
            )}
          </Button>
          <Button type="submit" data-testid="submit" unelevated>
            {intl.formatMessage(
              messages.sampleDrawMPSelectAddressNextButtonText
            )}
          </Button>
          {onBack && (
            <Button type="reset" data-testid="cancel" onClick={onBack}>
              {intl.formatMessage(
                messages.sampleDrawMPSelectAddressBackButtonText
              )}
            </Button>
          )}
        </>
      }
    />
  );
};

export default SampleDrawMPSelectAddress;
